import { convert } from "./converters";

export const findNearestPXValue = (arr, value) =>
  arr.reduce(
    (acc, item) =>
      Math.abs(acc) > Math.abs(item - value) ? item - value : acc,
    Infinity
  ) + value;

export const getNearestValuesOf = (config, variable, baseFontSize) => {
  const withPx = config.map((value) => ({
    ...value,
    pxValue: convert(value, baseFontSize),
  }));
  
  const number = parseFloat(variable);

  const px = withPx
    .map((item) => parseInt(item.pxValue))
    .filter((val) => !isNaN(val))
    .sort(function (a, b) {
      return a - b;
    });

  const nearest = findNearestPXValue(px, number);

  const nearestIndex = px.indexOf(nearest);
  const indexes = [ nearestIndex, nearestIndex + 1 , nearestIndex - 1];

  

  return indexes
    .map((index) => {
      const val = withPx.find((wi) => wi.pxValue === px[index]);
      if (!val) {
        return undefined;
      }
      return {
        ...val,
        nearest: val.pxValue === px[nearestIndex],
      };
    })
    .filter(Boolean);
};
